module.exports = __webpack_public_path__ + "static/media/rapidez.dff5846f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/aeropost/rapidez.png
// module id = 1201
// module chunks = 0